angular
  .module('contrast.services.charts', [])
  .factory(
    'ChartService',
    function ($, $window, $translate, $filter, RULE_SEVERITY_ENUM) {
      'ngInject'

      function parseBreakdownDetails(details, key, isAttack) {
        var result = []

        isAttack = isAttack || false

        angular.forEach(details, function (detail) {
          if (detail[isAttack ? 'count' : 'traces'] > 0) {
            result.push(
              detail[isAttack ? 'count' : 'traces'] + ' ' + detail[key]
            )
          }
        })

        return result
      }

      var traceSeveritiesOrdered = [
          'critical',
          'high',
          'medium',
          'low',
          'note'
        ],
        traceStatusesOrdered = [
          'confirmed',
          'suspicious',
          'not a problem',
          'remediated',
          'reported'
        ],
        attackStatusesOrdered = ['exploited', 'blocked', 'probed'],
        attackTypesOrdered = ['manual', 'automated']

      return {
        getTraceBreakdownTypes: function () {
          return ['Severity', 'Status', 'Type']
        },
        getAttackBreakdownTypes: function () {
          return ['Status', 'Type']
        },

        buildTraceThermometerData: function (breakdown, response) {
          var data = {
            count: response.total_vulnerabilities,
            data: []
          }

          var responseData = response.traces_breakdown

          angular.forEach(responseData, function (datum) {
            var record = {
              count: 0,
              tooltip: {
                title: '',
                body: ''
              },
              class: 'clickable ',
              name: '',
              type: 'vuln',
              link: true,
              breakdown: breakdown
            }

            switch (breakdown) {
              case 'Severity':
                record.count = datum.traces
                /*TODO i18n-003*/
                record.tooltip.title =
                  datum.severity.charAt(0).toUpperCase() +
                  datum.severity.substring(1).toLowerCase() +
                  ' Vulnerabilities'
                record.tooltip.body = parseBreakdownDetails(
                  datum.details,
                  'status'
                )
                record.class += 'therm-' + datum.severity.toLowerCase()
                record.name = datum.severity.toLowerCase()
                record.keycode =
                  datum.severity.charAt(0).toUpperCase() +
                  datum.severity.substring(1).toLowerCase()
                break

              case 'Status':
                record.count = datum.total_vulnerabilities
                record.tooltip.title = datum.status
                record.tooltip.body = parseBreakdownDetails(
                  datum.details,
                  'severity'
                )
                record.class +=
                  'therm-' + datum.status.toLowerCase().replace(' ', '-')
                record.name = datum.status.toLowerCase()
                record.keycode = datum.status
                break

              case 'Type':
                record.count = datum.traces
                record.tooltip.title = datum.rule_title
                record.tooltip.body = parseBreakdownDetails(
                  datum.details,
                  'status'
                )
                record.class += 'therm-type'
                record.name = datum.rule_title.toLowerCase()
                record.keycode = datum.rule_name
                break

              default:
                break
            }

            if (record.count > 0) {
              data.data.push(record)
            }
          })

          if (breakdown == 'Severity') {
            data.data.sort(function (a, b) {
              return (
                traceSeveritiesOrdered.indexOf(a.name) -
                traceSeveritiesOrdered.indexOf(b.name)
              )
            })
          } else if (breakdown == 'Status') {
            data.data.sort(function (a, b) {
              return (
                traceStatusesOrdered.indexOf(a.name) -
                traceStatusesOrdered.indexOf(b.name)
              )
            })
          } else if (breakdown == 'Type' && data.data.length > 8) {
            var others = data.data.slice(8),
              tooltipBody = []

            var record = {
              count: 0,
              tooltip: {
                title: 'Others',
                body: []
              },
              class: 'clickable therm-type',
              type: 'vuln',
              link: true,
              breakdown: breakdown,
              // Create list of rule names to be used in thermometer chart directive for filtering the vulns grid
              keycodes: others.map((o) => o.keycode)
            }

            var othersLen = others.length > 5 ? 5 : others.length,
              additional = others.length > 5 ? others.length - 5 : 0,
              i = 0,
              other = null

            for (; i < others.length; i++) {
              other = others[i]
              if (i < othersLen) {
                tooltipBody.push(other.tooltip.title)
              }
              record.count += other.count
            }
            if (additional > 0) {
              tooltipBody.push('+ ' + additional + ' more')
            }

            record.tooltip.body = tooltipBody

            data.data = data.data.slice(0, 8).concat([record])
          }

          return data
        },
        buildAttackThermometerData: function (breakdown, response) {
          var data = {
            count: response.total_attacks,
            data: []
          }

          var responseData = response.attack_breakdown

          angular.forEach(responseData, function (datum) {
            var record = {
              count: 0,
              tooltip: {
                title: '',
                body: ''
              },
              class: ['clickable'],
              link: true,
              type: 'attack',
              breakdown: breakdown
            }

            switch (breakdown) {
              case 'Status':
                record.count = datum.count
                record.tooltip.title = datum.status
                record.tooltip.body = parseBreakdownDetails(
                  datum.details,
                  'type',
                  true
                )
                record.class.push(
                  'therm-' + datum.status.toLowerCase().replace(' ', '-')
                )
                record.name = datum.status.toLowerCase()
                break

              case 'Type':
                record.count = datum.count
                record.tooltip.title = datum.type
                record.tooltip.body = parseBreakdownDetails(
                  datum.details,
                  'status',
                  true
                )
                record.class.push(
                  'therm-' + datum.type.toLowerCase().replace(' ', '-')
                )
                record.name = datum.type.toLowerCase()
                break

              default:
                break
            }

            record.class = record.class.join(' ')

            if (record.count > 0) {
              data.data.push(record)
            }
          })

          if (breakdown == 'Status') {
            data.data.sort(function (a, b) {
              return (
                attackStatusesOrdered.indexOf(a.name) -
                attackStatusesOrdered.indexOf(b.name)
              )
            })
          } else if (breakdown == 'Type') {
            data.data.sort(function (a, b) {
              return (
                attackTypesOrdered.indexOf(a.name) -
                attackTypesOrdered.indexOf(b.name)
              )
            })
          }

          return data
        },

        getIntervals: function () {
          return [
            {
              value: 'WEEK',
              description: 'Last 7 Days'
            },
            {
              value: 'MONTH',
              description: 'Last 30 Days'
            },
            {
              value: 'YEAR',
              description: 'Last 12 Months'
            }
          ]
        },

        buildAttackMonitorData: function (data, clickHandler) {
          var max =
              data.reduce(function (current, record) {
                return record.total_events > current
                  ? record.total_events
                  : current
              }, 1) + 1,
            minTime = data.reduce(function (current, record) {
              return record.timestamp < current ? record.timestamp : current
            }, data[0].timestamp),
            maxTime = data.reduce(function (current, record) {
              return record.timestamp > current ? record.timestamp : current
            }, data[0].timestamp)

          var config = [
            {
              group: function (d) {
                return d.probed_events
              },
              class: 'bar-chart-gray'
            },
            {
              group: function (d) {
                return d.blocked_events
              },
              class: 'bar-chart-green'
            },
            {
              group: function (d) {
                return d.exploited_events
              },
              class: 'bar-chart-red'
            },
            {
              group: function (d) {
                return d.total_events
              },
              class: 'bar-chart-transparent'
            }
          ]

          return {
            data: data,
            config: config,
            max: max,
            min: 0,
            minTime: minTime,
            maxTime: maxTime,
            clickHandler: clickHandler
          }
        },

        buildShortAttackMonitorData: function (data, shorter) {
          var datumPerGroup = shorter ? 4 : 2

          var shortData = []
          for (
            var i = 0;
            i < data.length - datumPerGroup - 1;
            i += datumPerGroup
          ) {
            shortData.push({
              timestamp: data[i].timestamp,
              requests_per_second:
                sumFn(data, 'requests_per_second', i, datumPerGroup) / 3,
              requests: sumFn(data, 'requests', i, datumPerGroup),
              exploited_events: sumFn(
                data,
                'exploited_events',
                i,
                datumPerGroup
              ),
              probed_events: sumFn(data, 'probed_events', i, datumPerGroup),
              blocked_events: sumFn(data, 'blocked_events', i, datumPerGroup),
              total_events: sumFn(data, 'total_events', i, datumPerGroup)
            })
          }
          data = shortData

          var max =
              data.reduce(function (current, record) {
                return record.total_events > current
                  ? record.total_events
                  : current
              }, 1) + 1,
            minTime = data.reduce(function (current, record) {
              return record.timestamp < current ? record.timestamp : current
            }, data[0].timestamp),
            maxTime = data.reduce(function (current, record) {
              return record.timestamp > current ? record.timestamp : current
            }, data[0].timestamp)

          var config = [
            {
              group: function (d) {
                return d.total_events
              }
            }
          ]

          var timeDomain = d3.time.scale().domain([minTime, maxTime])

          return {
            data: data,
            config: config,
            max: max,
            min: 0,
            minTime: minTime,
            maxTime: maxTime,
            barWidth: function () {
              return $window.matchMedia('(max-width: 991px)').matches ? 10 : 20
            },
            chartMethods: function (chart) {
              chart
                .linearColors(['#eeeeee', '#bfbfbf'])
                .colorAccessor(function (d) {
                  return timeDomain(d.key)
                })
            }
          }
        },

        buildTraceRemediationData: function (response) {
          var transl = {
            detail_timeUnitDays: $translate.instant('detail_timeUnitDays')
          }

          transl.detail_timeUnitDays = $filter('capitalize')(
            transl.detail_timeUnitDays
          )

          var trend = response.trend,
            min = Infinity,
            validSeverities = [
              RULE_SEVERITY_ENUM.MEDIUM,
              RULE_SEVERITY_ENUM.HIGH,
              RULE_SEVERITY_ENUM.CRITICAL
            ]

          var max =
            trend.reduce(function (currentMax, trendPoint) {
              var pointMax = trendPoint.stats.reduce(function (
                currentPointMax,
                trendPointStat
              ) {
                if (validSeverities.indexOf(trendPointStat.label) > -1) {
                  return trendPointStat.average > currentPointMax
                    ? trendPointStat.average
                    : currentPointMax
                }
                return currentPointMax
              },
              1)

              return pointMax > currentMax ? pointMax : currentMax
            }, 1) + 1

          var config = [
            {
              group: function (d) {
                return d.stats.find(function (rec) {
                  return rec.label == 'Medium'
                }).average
              },
              tooltip: {
                class:
                  'tooltip-robust time-series-tooltip time-remediation-medium',
                title: transl.detail_timeUnitDays,
                position: 'right'
              },
              class: 'time-series-remediation-medium',
              hidePoint: true
            },
            {
              group: function (d) {
                return d.stats.find(function (rec) {
                  return rec.label == 'High'
                }).average
              },
              tooltip: {
                class:
                  'tooltip-robust time-series-tooltip time-remediation-high',
                title: transl.detail_timeUnitDays,
                position: 'right'
              },
              class: 'time-series-remediation-high',
              hidePoint: true
            },
            {
              group: function (d) {
                return d.stats.find(function (rec) {
                  return rec.label == 'Critical'
                }).average
              },
              tooltip: {
                class:
                  'tooltip-robust time-series-tooltip time-remediation-critical',
                title: transl.detail_timeUnitDays,
                position: 'right'
              },
              class: 'time-series-remediation-critical',
              hidePoint: true
            }
          ]

          return {
            data: trend,
            config: config,
            max: max,
            min: min > 0 && min != Infinity ? min - 1 : 0,
            showToday: true
          }
        },

        buildScoreTrendData: function (response) {
          var defenseEnabled = response.find(function (rec) {
              return rec.defense
            }),
            history = response.find(function (rec) {
              return rec.history
            })

          var overall = []
          angular.forEach(history.history.total, function (totalRecord) {
            if (defenseEnabled) {
              var defenseScore = defenseEnabled.defense.total.find(function (
                rec
              ) {
                return Math.abs(rec.timestamp - totalRecord.timestamp) < 1000
              })

              overall.push({
                value: totalRecord.score,
                defense: defenseScore ? defenseScore.score : totalRecord.score,
                timestamp: totalRecord.timestamp
              })
            } else {
              overall.push({
                value: totalRecord.score,
                timestamp: totalRecord.timestamp
              })
            }
          })

          var config = []

          if (defenseEnabled) {
            config = [
              {
                group: function (d) {
                  return d.defense
                },
                tooltip: {
                  class: 'time-series-tooltip time-defense',
                  title: 'Score With Protection'
                },
                class: 'time-series-defense'
              },
              {
                group: function (d) {
                  return d.value
                },
                tooltip: {
                  class: 'time-series-tooltip',
                  title: 'Overall Score'
                },
                class: 'time-series-overall'
              }
            ]
          } else {
            config = [
              {
                group: function (d) {
                  return d.value
                },
                tooltip: {
                  class: 'time-series-tooltip',
                  title: 'Overall Score'
                },
                class: 'time-series-overall'
              }
            ]
          }

          return {
            data: overall,
            config: config,
            max: 100
          }
        },

        buildAttackTrendData: function (response, interval) {
          var data = [],
            max = 1
          angular.forEach(response.data.items, function (totalRecord) {
            var timestamp
            if (interval == 'YEAR' || interval == 'Last Year') {
              timestamp = moment(totalRecord.creation, 'x')
                .startOf('month')
                .format('x')
            } else {
              timestamp = moment(totalRecord.creation, 'x')
                .startOf('day')
                .format('x')
            }
            data.push({
              value: totalRecord.total_attacks,
              timestamp: timestamp
            })

            if (totalRecord.total_attacks >= max) {
              max = totalRecord.total_attacks + 1
            }
          })
          return {
            data: data,
            config: [
              {
                group: function (d) {
                  return d.value
                },
                tooltip: {
                  class: 'time-series-tooltip time-attack',
                  title: 'Attacks'
                },
                class: 'time-series-attacks'
              }
            ],
            max: max
          }
        },
        buildServerActivityTrendData: function (data, interval) {
          var items = data.items,
            max = 1

          var overall = []
          angular.forEach(items, function (item) {
            overall.push({
              value: item.count,
              timestamp: item.start
            })

            if (item.count >= max) {
              max = item.count + 1
            }
          })

          var tooltipTemplate = undefined
          if (interval == 'YEAR') {
            tooltipTemplate = 'timeSeriesYearTooltip.html'
          }

          var config = [
            {
              tooltipTemplate: tooltipTemplate,
              group: function (d) {
                return d.value
              },
              tooltip: {
                class: 'time-series-tooltip',
                title: 'Agent Reports'
              },
              class: 'time-series-overall'
            }
          ]

          return {
            data: overall,
            config: config,
            max: max
          }
        },

        buildSparklineScoreTrendData: function (total) {
          total.sort(function (a, b) {
            return a.score - b.score
          })

          var config = {
            group: function (d) {
              return d.score
            },
            dimension: function (d) {
              return d.timestamp
            },
            yScale: d3.scale
              .linear()
              .domain([total[0].score, total[total.length - 1].score]),
            xScale: d3.time
              .scale()
              .domain([
                new Date(new Date().setDate(new Date().getDate() - 7)),
                new Date()
              ]),
            classAccessor: function (value) {
              var className = 'score-gradient score-gradient-'
              className +=
                value > 89
                  ? 'a'
                  : value > 79
                  ? 'b'
                  : value > 69
                  ? 'c'
                  : value > 59
                  ? 'd'
                  : 'f'

              return className
            }
          }

          return {
            data: total,
            config: config
          }
        },

        buildSparklineAttackTrendData: function (data) {
          data.sort(function (a, b) {
            return a.total_attacks - b.total_attacks
          })

          var config = {
            group: function (d) {
              return d.total_attacks
            },
            dimension: function (d) {
              return d.creation
            },
            yScale: d3.scale
              .linear()
              .domain([
                data[0].total_attacks,
                data[data.length - 1].total_attacks
              ]),
            xScale: d3.time
              .scale()
              .domain([
                new Date(new Date().setDate(new Date().getDate() - 7)),
                new Date()
              ]),
            classAccessor: function () {
              return 'stroke-color-red'
            }
          }

          return {
            data: data,
            config: config
          }
        },

        buildDisabledSparklineData: function (trendingUp) {
          var data = [
            {
              x: 0,
              y: 1 - (trendingUp ? 0.8 : 0.2)
            }
          ]

          for (var i = 1; i < 5; i++) {
            data.push({
              x: i,
              y: Math.random()
            })
          }

          data.push({
            x: 5,
            y: 1 - (trendingUp ? 0.2 : 0.8)
          })

          var config = {
            group: function (d) {
              return d.y
            },
            dimension: function (d) {
              return d.x
            },
            yScale: d3.scale.linear().domain([0, 1]),
            xScale: d3.scale.linear().domain([0, 5]),
            classAccessor: function () {
              return 'stroke-color-gray'
            }
          }

          return {
            data: data,
            config: config
          }
        },

        buildLicensesUseData: function (breakdown, dateFormat) {
          var unusedLicenses = breakdown.licenses - breakdown.used_licenses

          var data = {
            count: breakdown.licenses,
            data: []
          }

          /*TODO i18n-004*/
          var transl = {
            title_expire_date:
              ' ' + $translate.instant('title_expire_date') + ' ',
            title_usedLicenses: $translate.instant('title_usedLicenses'),
            title_unusedLicenses: $translate.instant('title_unusedLicenses')
          }

          var tooltipUsedLicenses = []
          $.each(breakdown.expiration_date_licenses, function (_key, detail) {
            var expirationString = moment(detail.expiration).formatWithJDF(
              dateFormat
            )
            if (breakdown.expiration_date_licenses.length == 1) {
              tooltipUsedLicenses.push(
                transl.title_expire_date + expirationString
              )
            } else {
              tooltipUsedLicenses.push(
                detail.licenses + transl.title_expire_date + expirationString
              )
            }
          })

          var recordUsed = {
            count: breakdown.used_licenses,
            tooltip: {
              title: transl.title_usedLicenses,
              body: tooltipUsedLicenses
            },
            class: 'therm-used-licenses',
            name: transl.title_usedLicenses
          }

          var tooltipUnusedLicenses = []
          $.each(
            breakdown.expiration_date_unused_licenses,
            function (_key, detail) {
              var expirationString = moment(detail.expiration).formatWithJDF(
                dateFormat
              )
              if (breakdown.expiration_date_unused_licenses.length == 1) {
                tooltipUnusedLicenses.push(
                  transl.title_expire_date + expirationString
                )
              } else {
                tooltipUnusedLicenses.push(
                  detail.licenses + transl.title_expire_date + expirationString
                )
              }
            }
          )

          var recordUnused = {
            count: unusedLicenses,
            tooltip: {
              title: transl.title_unusedLicenses,
              body: tooltipUnusedLicenses
            },
            class: 'therm-unused-licenses',
            name: transl.title_unusedLicenses
          }

          if (recordUsed.count > 0) {
            data.data.push(recordUsed)
          }
          if (recordUnused.count > 0) {
            data.data.push(recordUnused)
          }

          return data
        },

        buildLicenseSummary: function (breakdown, dateFormat) {
          var data = {
            count: breakdown.total,
            data: []
          }

          /*TODO i18n-005*/
          var transl = {
            title_expire_date:
              ' ' + $translate.instant('title_expire_date') + ' ',
            title_usedLicenses: $translate.instant('title_usedLicenses'),
            title_unusedLicenses: $translate.instant('title_unusedLicenses')
          }

          var tooltipUsedLicenses = []
          $.each(
            breakdown.expiration_date_used_licenses,
            function (_key, detail) {
              var expirationString = moment(detail.expiration).formatWithJDF(
                dateFormat
              )
              if (breakdown.expiration_date_used_licenses.length == 1) {
                tooltipUsedLicenses.push(
                  transl.title_expire_date + expirationString
                )
              } else {
                tooltipUsedLicenses.push(
                  detail.licenses + transl.title_expire_date + expirationString
                )
              }
            }
          )

          var recordUsed = {
            count: breakdown.used,
            tooltip: {
              title: transl.title_usedLicenses,
              body: tooltipUsedLicenses
            },
            class: 'therm-used-licenses',
            name: transl.title_usedLicenses
          }

          var tooltipUnusedLicenses = []
          $.each(
            breakdown.expiration_date_unused_licenses,
            function (_key, detail) {
              var expirationString = moment(detail.expiration).formatWithJDF(
                dateFormat
              )
              if (breakdown.expiration_date_unused_licenses.length == 1) {
                tooltipUnusedLicenses.push(
                  transl.title_expire_date + expirationString
                )
              } else {
                tooltipUnusedLicenses.push(
                  detail.licenses + transl.title_expire_date + expirationString
                )
              }
            }
          )

          var recordUnused = {
            count:
              breakdown.revoke_count &&
              breakdown.revoke_count > 0 &&
              breakdown.revoke_count <= breakdown.unused
                ? breakdown.unused - breakdown.revoke_count
                : breakdown.unused,
            tooltip: {
              title: transl.title_unusedLicenses,
              body: tooltipUnusedLicenses
            },
            class: 'therm-unused-licenses',
            name: transl.title_unusedLicenses
          }

          if (recordUsed.count > 0) {
            data.data.push(recordUsed)
          }
          if (recordUnused.count >= 0) {
            data.data.push(recordUnused)
          }

          return data
        },

        buildProtectionModeData: function (env, total) {
          var transl = {
            title_ruleModeOffApplications: $translate.instant(
              'title_ruleModeOffApplications'
            ),
            title_ruleModeMonitoringApplications: $translate.instant(
              'title_ruleModeMonitoringApplications'
            ),
            title_ruleModeBlockingApplications: $translate.instant(
              'title_ruleModeBlockingApplications'
            ),
            title_ruleModeBlockingAtPerimeterApplications: $translate.instant(
              'title_ruleModeBlockingAtPerimeterApplications'
            ),
            title_ruleModeMonitorAtPerimeterApplications: $translate.instant(
              'title_ruleModeMonitorAtPerimeterApplications'
            )
          }

          var data = {
            count: total,
            data: []
          }
          if (total > 0) {
            var tooltipOffApp = []
            var i
            for (i = 0; i < env.off_applications.length; i++) {
              tooltipOffApp.push(env.off_applications[i])
            }
            var recordOff = {
              count: env.total_off_apps,
              tooltip: {
                title: transl.title_ruleModeOffApplications,
                body: tooltipOffApp
              },
              class: 'thermometer-off',
              name: 'Applications Off'
            }

            var tooltipMonitorApp = []
            for (i = 0; i < env.monitoring_applications.length; i++) {
              tooltipMonitorApp.push(env.monitoring_applications[i])
            }
            var recordMonitoring = {
              count: env.total_monitoring_apps,
              tooltip: {
                title: transl.title_ruleModeMonitoringApplications,
                body: tooltipMonitorApp
              },
              class: 'thermometer-monitor',
              name: 'Applications (Monitor)'
            }

            var tooltipMonitorPerimeterApp = []
            for (i = 0; i < env.monitor_perimeter_applications.length; i++) {
              tooltipMonitorPerimeterApp.push(
                env.monitor_perimeter_applications[i]
              )
            }
            var recordMonitorPerimeter = {
              count: env.total_monitor_perimeter_apps,
              tooltip: {
                title: transl.title_ruleModeMonitorAtPerimeterApplications,
                body: tooltipMonitorPerimeterApp
              },
              class: 'thermometer-monitor',
              name: 'Applications (Monitor At Perimeter)'
            }

            var tooltipBlockApp = []
            for (i = 0; i < env.blocking_applications.length; i++) {
              tooltipBlockApp.push(env.blocking_applications[i])
            }
            var recordBlocking = {
              count: env.total_blocking_apps,
              tooltip: {
                title: transl.title_ruleModeBlockingApplications,
                body: tooltipBlockApp
              },
              class: 'thermometer-block',
              name: 'Applications (Block)'
            }

            var tooltipBlockPerimeterApp = []
            for (i = 0; i < env.blocking_perimeter_applications.length; i++) {
              tooltipBlockPerimeterApp.push(
                env.blocking_perimeter_applications[i]
              )
            }
            var recordBlockingPerimeter = {
              count: env.total_blocking_perimeter_apps,
              tooltip: {
                title: transl.title_ruleModeBlockingAtPerimeterApplications,
                body: tooltipBlockPerimeterApp
              },
              class: 'thermometer-block-perimeter',
              name: 'Applications (Blocking at Perimeter)'
            }

            if (recordOff.count > 0) {
              data.data.push(recordOff)
            }
            if (recordMonitoring.count > 0) {
              data.data.push(recordMonitoring)
            }
            if (recordBlocking.count > 0) {
              data.data.push(recordBlocking)
            }
            if (recordBlockingPerimeter.count > 0) {
              data.data.push(recordBlockingPerimeter)
            }
            if (recordMonitorPerimeter.count > 0) {
              data.data.push(recordMonitorPerimeter)
            }
          }

          return data
        },

        buildAssessModeData: function (env, total) {
          var data = {
            count: total,
            data: []
          }
          if (total > 0) {
            var tooltipOffApp = []
            var i
            for (i = 0; i < env.off_applications.length; i++) {
              tooltipOffApp.push(env.off_applications[i].appName)
            }
            var recordOff = {
              count: env.off_applications.length,
              tooltip: {
                title: $translate.instant('title_ruleModeOffApplications'),
                body: tooltipOffApp
              },
              class: 'thermometer-off',
              name: 'Applications Off'
            }

            var tooltipOnApp = []
            for (i = 0; i < env.on_applications.length; i++) {
              tooltipOnApp.push(env.on_applications[i].appName)
            }
            var recordOn = {
              count: env.on_applications.length,
              tooltip: {
                title: $translate.instant('title_ruleModeOnApplications'),
                body: tooltipOnApp
              },
              class: 'thermometer-on',
              name: 'Applications On'
            }

            if (recordOff.count > 0) {
              data.data.push(recordOff)
            }
            if (recordOn.count > 0) {
              data.data.push(recordOn)
            }
          }

          return data
        }
      }

      function sumFn(data, property, index, count) {
        var sum = 0,
          i = 0
        for (; i < count; i++) {
          sum += data[index + i][property]
        }
        return sum
      }
    }
  )
